import { WasteComponent } from "./wasteComponent";
import { Items } from "../context/UserDetails";

const Wastes: React.FC<{ items: Array<Items> }> = ({ items }): JSX.Element => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        
        {/* ===== SECTION 1: HEADER ===== */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-3">
            What We Accept
          </h2>
          <div className="w-16 h-1 bg-green-600 mx-auto rounded-full mb-4"></div>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We purchase recyclable materials from individuals, businesses, and communities. Turn your waste into cash with competitive rates and same-day payment.
          </p>
        </div>

        {/* ===== SECTION 2: BENEFITS ===== */}
        <div className="grid md:grid-cols-3 gap-4 mb-12">
          <div className="bg-green-50 border border-green-100 rounded-xl p-4 text-center">
            <span className="text-2xl">💰</span>
            <p className="font-semibold text-gray-800 text-sm mt-1">Competitive Rates</p>
          </div>
          <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 text-center">
            <span className="text-2xl">💵</span>
            <p className="font-semibold text-gray-800 text-sm mt-1">Same Day Payment</p>
          </div>
          <div className="bg-amber-50 border border-amber-100 rounded-xl p-4 text-center">
            <span className="text-2xl">🏠</span>
            <p className="font-semibold text-gray-800 text-sm mt-1">Deliver to Our Office</p>
          </div>
        </div>

        {/* ===== SECTION 3: MATERIALS WE BUY ===== */}
        <div className="mb-12">
          <h3 className="text-xl font-bold text-center text-gray-800 mb-6">
            Materials We Buy
          </h3>
          
          <div className="grid md:grid-cols-3 gap-6">
            {/* Plastics */}
            <div className="border border-green-200 rounded-xl p-5 bg-white hover:shadow-md transition">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-2xl">♻️</span>
                <h4 className="font-bold text-gray-800">Plastics</h4>
              </div>
              <p className="text-sm text-gray-500 mb-3">All types of plastic materials accepted</p>
              <div className="flex flex-wrap gap-1.5">
                {["PET Bottles", "HDPE", "LDPE", "PP", "Pure Water Sachets", "Plastic Containers"].map((item) => (
                  <span key={item} className="text-xs bg-gray-50 px-2.5 py-1 rounded-full border border-gray-100">
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Metals */}
            <div className="border border-blue-200 rounded-xl p-5 bg-white hover:shadow-md transition">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-2xl">🥫</span>
                <h4 className="font-bold text-gray-800">Metals</h4>
              </div>
              <p className="text-sm text-gray-500 mb-3">Ferrous and non-ferrous metals</p>
              <div className="flex flex-wrap gap-1.5">
                {["Aluminium Cans", "Tin Containers", "Scrap Metal", "Steel Cans"].map((item) => (
                  <span key={item} className="text-xs bg-gray-50 px-2.5 py-1 rounded-full border border-gray-100">
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Paper & Glass */}
            <div className="border border-purple-200 rounded-xl p-5 bg-white hover:shadow-md transition">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-2xl">📄</span>
                <h4 className="font-bold text-gray-800">Paper &amp; Glass</h4>
              </div>
              <p className="text-sm text-gray-500 mb-3">Clean paper products and glass containers</p>
              <div className="flex flex-wrap gap-1.5">
                {["Used Paper", "Cardboard", "Glass Bottles", "Newspapers", "Magazines"].map((item) => (
                  <span key={item} className="text-xs bg-gray-50 px-2.5 py-1 rounded-full border border-gray-100">
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ===== SECTION 4: WASTE ITEMS GRID ===== */}
        <WasteComponent items={items} />

        {/* ===== SECTION 5: HOW IT WORKS ===== */}
        <div className="mt-8 bg-white rounded-xl p-8 border border-gray-100">
          <h3 className="text-xl font-bold text-center text-gray-800 mb-6">
            How It Works
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2 text-green-600 font-bold text-lg">
                1
              </div>
              <p className="font-semibold text-gray-800">Contact Us</p>
              <p className="text-sm text-gray-500">Call or WhatsApp us</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2 text-blue-600 font-bold text-lg">
                2
              </div>
              <p className="font-semibold text-gray-800">Deliver to Our Office</p>
              <p className="text-sm text-gray-500">Bring your recyclables to us</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-2 text-amber-600 font-bold text-lg">
                3
              </div>
              <p className="font-semibold text-gray-800">Get Paid</p>
              <p className="text-sm text-gray-500">Receive payment on the spot</p>
            </div>
          </div>
        </div>

        {/* ===== SECTION 6: OFFICE ADDRESS ===== */}
        <div className="mt-6 bg-gray-50 rounded-xl p-5 border border-gray-200 text-center">
          <p className="text-sm text-gray-600">
             <span className="font-medium">Our Office:</span> Phase 2 Temidire Market, Eleyele, Ibadan, Oyo State
          </p>
        </div>

        {/* ===== SECTION 7: CTA ===== */}
        <div className="text-center mt-10">
          <p className="text-gray-600 text-sm mb-3">
            Got other recyclable materials? Contact us for a quote.
          </p>
          <button
            onClick={() => {
              const message = "Hello GJC Recycling, I have recyclable materials to sell. Please provide a quote.";
              window.open(`https://wa.me/2348038551338?text=${encodeURIComponent(message)}`, '_blank');
            }}
            className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-2.5 rounded-lg text-sm font-medium transition-all duration-300 shadow-sm hover:shadow-md"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            Inquire About Other Materials
          </button>
        </div>
      </div>
    </section>
  );
};

export default Wastes;